module.exports = __webpack_public_path__ + "static/Filing-Step-bb3c4cbbc09a7f7c0ad9f66d19f8c821.png";